import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Loader from "components/loader";
import UploadIcon from "assets/icons/upload_icon.svg";
import Upload from "assets/upload.svg";
import Fileicon from "assets/fileicon.svg";
import Redwarning from "assets/exclamanation.svg";
import bwarning from "assets/warning.svg";
import CrossSignal from "assets/cross-circle_red.svg";
import Closebutton from "assets/closeicon.svg";
import SendMail from "./sendMail";
export default function FileUploadPopUp({
  openFilePopUp,
  setFilePopUp,
  onFileUpload,
  fileValue,
  fileStatus,

  handleDeleteFile,
  setStepsData,
  HandleonSubmit
}) {
  const [selectFile, setSelectFile] = useState(false);
  const [unSupportedFile, setUnSupportedFile] = useState(false);

  const handleClose = () => {
    if (fileValue.length === 0) {
      setSelectFile(true);
    } else {
      setSelectFile(false);
      setFilePopUp(false);
      HandleonSubmit();
    }

    // setLoader(false)
  };

  useEffect(() => {
    const haveWrongFile = fileValue?.some((file) => file?.noOfWords === 0);
    setUnSupportedFile(haveWrongFile);
  }, [fileValue]);


  return (
    <>
      {openFilePopUp && (
        <React.Fragment>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none font-primary bg-[#00000080]">
            <div className="relative  flex items-center justify-between lg:max-w-3xl md:max-w-2xl  sm:max-w-xl mx-auto  bg-white flex-col rounded-2xl px-4 sm:px-[40px]  py-[40px] w-11/12 sm:w-[680px]">
              <div className="flex justify-between w-full items-center">
                <h5 className="font-secondary text-[24px]  w-full font-semibold mb-4">
                  Upload your files
                </h5>

                <img
                  src={Closebutton}
                  alt="/"
                  onClick={() => {
                    setFilePopUp(false);
                    setSelectFile(false);
                    
                  }}
                  className="cursor-pointer mb-2  bg-white p-2 rounded-[4px]  border-2 border-[#0000001a] "
                />
              </div>
              <div
                className={`w-full ${
                  fileValue?.length != 0 ? "" : ""
                }   w-full h-auto rounded-lg mt-3  flex items-center justify-center relative flex-col`}
              >
                <div className="w-full flex items-center justify-center">
                  <input
                    multiple
                    type="file"
                    placeholder=".pdf, .docx, .txt"
                    value=""
                    className={`inputfile cursor-pointer ${
                      fileValue?.length != 0 ? " h-[126px] sm:h-[113px]" : "h-[126px] md:h-[113px]"
                    }`}
                    onChange={onFileUpload}
                    onClick={() => setSelectFile(false)}
                  />
                </div>

                <div className="flex flex-col bg-[#EBF3FF] border-dashed border border-[#95BFFF] w-full rounded-lg p-5 font-arial text-new text-quotetext-200 ">
                  <div className="w-full mr-2 flex gap-2 font-arial mb-3 sm:mb-0 items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M12.5 0C9.32935 0.0384714 6.29941 1.3151 4.05726 3.55726C1.8151 5.79941 0.538471 8.82935 0.5 12C0.538471 15.1706 1.8151 18.2006 4.05726 20.4427C6.29941 22.6849 9.32935 23.9615 12.5 24C15.6706 23.9615 18.7006 22.6849 20.9427 20.4427C23.1849 18.2006 24.4615 15.1706 24.5 12C24.4615 8.82935 23.1849 5.79941 20.9427 3.55726C18.7006 1.3151 15.6706 0.0384714 12.5 0ZM19.3571 12.8571H13.3571V18.8571H11.6429V12.8571H5.64286V11.1429H11.6429V5.14286H13.3571V11.1429H19.3571V12.8571Z"
                        fill="#2A7CF8"
                      />
                    </svg>
                    <p className="text-xl font-semibold text-black leading-6 font-opensans">
                      <span className="text-[#2A7CF8]">Add files</span>
                    </p>
                  </div>
                  <p className="text-[12px] mt-3 text-center font-opensans text-[#8A8A8A]">
                    Supported files .pdf, .docx, .txt.
                    <br /> Maximum file upload size: 200mb
                  </p>
                </div>
                {selectFile ? (
                  <span className="text-center font-secondary text-red transition-all scale-110 duration-100">
                    Please select File
                  </span>
                ) : null}
                <div
                  className={`${
                    fileValue?.length != 0
                      ? "max-h-[175px] mt-4 w-full overflow-y-auto"
                      : ""
                  } `}
                >
                  {fileStatus !== "loading"
                    ? fileValue?.map(
                        ({
                          originalName,
                          id,
                          noOfWords,
                          documentSize,
                          documentType,
                          message,
                        }) => (
                          <div
                            className={`flex justify-between gap-1  items-center w-full ${
                              noOfWords == 0
                                ? "border border-[#FFA4A4] bg-[#FFF5F5]"
                                : "border border-[#2A7CF8]"
                            }  mb-2 p-4 rounded-xl`}
                            key={id}
                          >
                            <div className="md:flex  justify-between w-full items-center gap-12">
                              <div className="flex items-center gap-4 font-arial w-full">
                                {noOfWords != 0 ? (
                                  <img src={Fileicon} alt="/" />
                                ) : (
                                  <div className="relative">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="32"
                                      height="36"
                                      viewBox="0 0 32 36"
                                      fill="none"
                                    >
                                      <path
                                        d="M18.8733 0.679016V10.5252C18.8733 11.3956 19.2191 12.2304 19.8346 12.8459C20.4501 13.4614 21.2849 13.8072 22.1554 13.8072H32.0015V30.2175C32.0015 31.0879 31.6557 31.9227 31.0402 32.5382C30.4247 33.1537 29.5899 33.4995 28.7195 33.4995H17.5441C19.2426 31.7315 20.2802 29.4323 20.4822 26.9889C20.6842 24.5455 20.0384 22.1071 18.6533 20.0841C17.2683 18.0611 15.2287 16.5769 12.8777 15.8814C10.5267 15.1859 8.00785 15.3216 5.74512 16.2655V3.96107C5.74512 3.09061 6.0909 2.25581 6.70641 1.64031C7.32191 1.0248 8.15671 0.679016 9.02717 0.679016H18.8733ZM21.3349 1.49953V10.5252C21.3349 10.7428 21.4213 10.9515 21.5752 11.1054C21.7291 11.2592 21.9378 11.3457 22.1554 11.3457H31.181L21.3349 1.49953Z"
                                        fill="#AEAEAE"
                                      />
                                      <path
                                        d="M18.0513 26.2954C18.0513 27.4806 17.8178 28.6543 17.3642 29.7493C16.9107 30.8444 16.2458 31.8393 15.4077 32.6774C14.5696 33.5156 13.5746 34.1804 12.4796 34.634C11.3846 35.0875 10.2109 35.321 9.02564 35.321C7.84038 35.321 6.66672 35.0875 5.57168 34.634C4.47664 34.1804 3.48166 33.5156 2.64355 32.6774C1.80544 31.8393 1.14062 30.8444 0.687036 29.7493C0.233455 28.6543 -1.76618e-08 27.4806 0 26.2954C3.56696e-08 23.9016 0.950913 21.6059 2.64355 19.9133C4.33618 18.2206 6.63189 17.2697 9.02564 17.2697C11.4194 17.2697 13.7151 18.2206 15.4077 19.9133C17.1004 21.6059 18.0513 23.9016 18.0513 26.2954ZM9.02564 20.5518C8.80803 20.5518 8.59933 20.6382 8.44545 20.7921C8.29157 20.946 8.20513 21.1547 8.20513 21.3723V27.9364C8.20513 28.154 8.29157 28.3627 8.44545 28.5166C8.59933 28.6704 8.80803 28.7569 9.02564 28.7569C9.24325 28.7569 9.45195 28.6704 9.60583 28.5166C9.75971 28.3627 9.84615 28.154 9.84615 27.9364V21.3723C9.84615 21.1547 9.75971 20.946 9.60583 20.7921C9.45195 20.6382 9.24325 20.5518 9.02564 20.5518ZM9.02564 32.2441C9.29766 32.2441 9.55853 32.136 9.75088 31.9437C9.94322 31.7513 10.0513 31.4904 10.0513 31.2184C10.0513 30.9464 9.94322 30.6855 9.75088 30.4932C9.55853 30.3008 9.29766 30.1928 9.02564 30.1928C8.75362 30.1928 8.49275 30.3008 8.3004 30.4932C8.10806 30.6855 8 30.9464 8 31.2184C8 31.4904 8.10806 31.7513 8.3004 31.9437C8.49275 32.136 8.75362 32.2441 9.02564 32.2441Z"
                                        fill="#F14848"
                                      />
                                    </svg>
                                  </div>
                                )}

                                <p className="flex flex-col ">
                                  <span
                                    className="text-[#0B0B0B]  font-opensans text-sm font-normal"
                                    // style={{ wordWrap: "break-word" }}
                                    style={{ wordBreak: "break-all" }}
                                  >
                                    {originalName}{" "}
                                  </span>
                                  {noOfWords != 0 ? (
                                    <span className="text-[#8B8B8B] text-[12px] font-opensans font-normal">
                                      {documentSize} {documentType}
                                    </span>
                                  ) : (
                                    <span className="text-[#ff0000] text-[12px] font-opensans font-normal">
                                      {documentSize} {documentType}
                                    </span>
                                  )}
                                  {/* {noOfWords == 0 && (
                                    <p className="flex gap-1 items-center sm:text-[12px] text-[#ff0000] font-arial">
                                      <img src={Redwarning} alt="" />
                                      {message}
                                    </p>
                                  )} */}
                                </p>
                              </div>
                              <div className="flex gap-2">
                                {noOfWords != 0 ? (
                                  <p className="w-max sm:text-[12px] text-[#8B8B8B] font-arial">
                                    {`(Total Words: ${noOfWords})`}
                                  </p>
                                ) : (
                                  ""
                                )}
                                <div
                                  onClick={() => handleDeleteFile(id)}
                                  className="hidden md:block cursor-pointer  h-6 bg-transparent filter-black"
                                >
                                  <svg
                                    width="15"
                                    height="16"
                                    viewBox="0 0 15 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      id="Vector"
                                      d="M0.314703 1.0647C0.414208 0.964947 0.532416 0.8858 0.662555 0.831798C0.792695 0.777796 0.93221 0.75 1.07311 0.75C1.21401 0.75 1.35352 0.777796 1.48366 0.831798C1.6138 0.8858 1.73201 0.964947 1.83152 1.0647L7.50028 6.73561L13.169 1.0647C13.2686 0.965108 13.3869 0.886104 13.517 0.832204C13.6471 0.778303 13.7866 0.750561 13.9275 0.750561C14.0683 0.750561 14.2078 0.778303 14.3379 0.832204C14.468 0.886104 14.5863 0.965108 14.6859 1.0647C14.7855 1.1643 14.8645 1.28254 14.9184 1.41266C14.9723 1.54279 15 1.68226 15 1.82311C15 1.96396 14.9723 2.10343 14.9184 2.23356C14.8645 2.36368 14.7855 2.48192 14.6859 2.58152L9.01495 8.25028L14.6859 13.919C14.7855 14.0186 14.8645 14.1369 14.9184 14.267C14.9723 14.3971 15 14.5366 15 14.6775C15 14.8183 14.9723 14.9578 14.9184 15.0879C14.8645 15.218 14.7855 15.3363 14.6859 15.4359C14.5863 15.5355 14.468 15.6145 14.3379 15.6684C14.2078 15.7223 14.0683 15.75 13.9275 15.75C13.7866 15.75 13.6471 15.7223 13.517 15.6684C13.3869 15.6145 13.2686 15.5355 13.169 15.4359L7.50028 9.76495L1.83152 15.4359C1.73192 15.5355 1.61368 15.6145 1.48356 15.6684C1.35343 15.7223 1.21396 15.75 1.07311 15.75C0.932261 15.75 0.79279 15.7223 0.662663 15.6684C0.532535 15.6145 0.414299 15.5355 0.314703 15.4359C0.215108 15.3363 0.136104 15.218 0.0822038 15.0879C0.0283032 14.9578 0.000560843 14.8183 0.000560843 14.6775C0.000560843 14.5366 0.0283032 14.3971 0.0822038 14.267C0.136104 14.1369 0.215108 14.0186 0.314703 13.919L5.98561 8.25028L0.314703 2.58152C0.214947 2.48201 0.1358 2.3638 0.0817982 2.23366C0.0277962 2.10352 0 1.96401 0 1.82311C0 1.68221 0.0277962 1.5427 0.0817982 1.41256C0.1358 1.28242 0.214947 1.16421 0.314703 1.0647Z"
                                      fill="#000000"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            <div
                              onClick={() => handleDeleteFile(id)}
                              className="block md:hidden cursor-pointer  h-6 bg-transparent filter-black"
                            >
                              <svg
                                width="15"
                                height="16"
                                viewBox="0 0 15 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  id="Vector"
                                  d="M0.314703 1.0647C0.414208 0.964947 0.532416 0.8858 0.662555 0.831798C0.792695 0.777796 0.93221 0.75 1.07311 0.75C1.21401 0.75 1.35352 0.777796 1.48366 0.831798C1.6138 0.8858 1.73201 0.964947 1.83152 1.0647L7.50028 6.73561L13.169 1.0647C13.2686 0.965108 13.3869 0.886104 13.517 0.832204C13.6471 0.778303 13.7866 0.750561 13.9275 0.750561C14.0683 0.750561 14.2078 0.778303 14.3379 0.832204C14.468 0.886104 14.5863 0.965108 14.6859 1.0647C14.7855 1.1643 14.8645 1.28254 14.9184 1.41266C14.9723 1.54279 15 1.68226 15 1.82311C15 1.96396 14.9723 2.10343 14.9184 2.23356C14.8645 2.36368 14.7855 2.48192 14.6859 2.58152L9.01495 8.25028L14.6859 13.919C14.7855 14.0186 14.8645 14.1369 14.9184 14.267C14.9723 14.3971 15 14.5366 15 14.6775C15 14.8183 14.9723 14.9578 14.9184 15.0879C14.8645 15.218 14.7855 15.3363 14.6859 15.4359C14.5863 15.5355 14.468 15.6145 14.3379 15.6684C14.2078 15.7223 14.0683 15.75 13.9275 15.75C13.7866 15.75 13.6471 15.7223 13.517 15.6684C13.3869 15.6145 13.2686 15.5355 13.169 15.4359L7.50028 9.76495L1.83152 15.4359C1.73192 15.5355 1.61368 15.6145 1.48356 15.6684C1.35343 15.7223 1.21396 15.75 1.07311 15.75C0.932261 15.75 0.79279 15.7223 0.662663 15.6684C0.532535 15.6145 0.414299 15.5355 0.314703 15.4359C0.215108 15.3363 0.136104 15.218 0.0822038 15.0879C0.0283032 14.9578 0.000560843 14.8183 0.000560843 14.6775C0.000560843 14.5366 0.0283032 14.3971 0.0822038 14.267C0.136104 14.1369 0.215108 14.0186 0.314703 13.919L5.98561 8.25028L0.314703 2.58152C0.214947 2.48201 0.1358 2.3638 0.0817982 2.23366C0.0277962 2.10352 0 1.96401 0 1.82311C0 1.68221 0.0277962 1.5427 0.0817982 1.41256C0.1358 1.28242 0.214947 1.16421 0.314703 1.0647Z"
                                  fill="#000000"
                                />
                              </svg>
                            </div>
                            {/* <FontAwesomeIcon
                        icon={faTrash}
                        className="text-red w-6 cursor-pointer"
                        onClick={() => handleDeleteFile(id)}
                      /> */}
                          </div>
                        )
                      )
                    : //  fileStatus === "loading" ? (
                      //   <Loader />
                      // ) :
                      null}
                </div>
                {(fileValue?.length != 0 || fileStatus !== "loading") && (
                  <SendMail unSupportedFile={unSupportedFile} />
                )}
              </div>

              <button
                disabled={unSupportedFile}
                className={` ${
                  fileValue?.length != 0 && !unSupportedFile
                    ? " bg-orange mt-6"
                    : "bg-[#00000033] mt-8 "
                } rounded-full py-[14px] text-xl px-20 text-white  
                font-opensans font-bold block mx-auto`}
                onClick={handleClose}
              >
                {fileStatus === "loading" ? <Loader /> : "Continue"}
              </button>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </React.Fragment>
      )}
    </>
  );
}
